import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import translate from "i18n/translate";
import basicAuthRequest from "axios/basicAuthRequest";
import { authSaveSessionData } from "redux/auth/actions";
import {
  PORTAL_LAYOUT_ROUTE,
  TRANSACTIONS_ROUTE,
} from "routes/portal/portalPaths";
import { AUTH_LOGIN } from "../../../../constants/api";

const useLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const login = async ({ email, password }) => {
    setLoading(true);
    setError("");

    try {
      const response = await basicAuthRequest.post(AUTH_LOGIN, {
        username: email,
        password,
      });

      const {
        connection: { token },
        result: operator,
        connectionSso: { accessToken } = {},
      } = response.data;

      await dispatch(authSaveSessionData({ token, accessToken, operator }));

      const route = history.location?.state;
      const url = operator?.operator
        ? PORTAL_LAYOUT_ROUTE + TRANSACTIONS_ROUTE
        : PORTAL_LAYOUT_ROUTE;
      const redirectTo = route?.from?.indexOf("auth") !== -1 ? url : route.from;

      history.push(redirectTo);
    } catch (err) {
      setError(
        err.response?.data?.error?.message || translate("errors.somethingWrong")
      );
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    login,
  };
};

export default useLogin;
